import { XRPC } from '@atcute/client';
import type { At } from '@atcute/client/lexicons';

import { Multiagent, type MultiagentAccountData } from '../classes/multiagent';

import { getCurrentAppView } from './appview';
import { initOAuth } from './oauth';

// Initialise the OAuth client (storage + client_id/redirect resolution) before
// the multiagent is constructed, so OAuth accounts can be resumed on boot.
initOAuth();

export const multiagent = new Multiagent('accs');

// Public (unauthenticated) AppView client. The service URL is resolved per
// request from the user's currently selected AppView, so switching AppViews in
// settings takes effect immediately without rebuilding this client.
export const publicAppView = new XRPC({
	handler: (pathname, init) => {
		const url = new URL(pathname, getCurrentAppView().url);
		return fetch(url, init);
	},
});

export const getAccountData = (uid: At.DID | undefined): MultiagentAccountData | undefined => {
	return uid !== undefined ? multiagent.accounts.find((acc) => acc.did === uid) : undefined;
};

export const renderAccountHandle = (account: MultiagentAccountData) => {
	// const handle = account.profile?.handle;
	// return handle && handle !== 'handle.invalid' ? handle : account.session.handle;

	return account.session.handle;
};

export const renderAccountName = (account: MultiagentAccountData) => {
	return account.profile?.displayName || `@` + account.session.handle;
};

export const getAccountHandle = (uid: At.DID): string | null => {
	const account = getAccountData(uid);

	if (account) {
		return renderAccountHandle(account);
	}

	return null;
};

export const getPrivilegedAccounts = () => {
	return multiagent.accounts.filter(isAccountPrivileged);
};

export const isAccountPrivileged = (account: MultiagentAccountData) => {
	return account.scope === undefined || account.scope === 'privileged';
};
